import { useMutation } from '@apollo/client';
import Button from '../components/Button';
import { Modal, ModalName, ModalPart } from '../components/Modal';
import { useToast } from '../components/Toast';
import { deleteSessionCache } from '../utilities/cache';
import { DELETE_SESSION } from '../utilities/mutations';

const DeleteSessionModal = ({ session, onClose }) => {
  const toast = useToast();
  const [deleteSession] = useMutation(DELETE_SESSION);

  const close = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal onClose={() => close()} isDanger>
      <ModalName>Remove session</ModalName>
      <ModalPart>Are you sure you want to delete this session?</ModalPart>
      <ModalPart>
        <Button onClick={() => close()} isExtended>
          Cancel
        </Button>
        <Button
          onClick={async () => {
            try {
              await deleteSession({
                variables: { id: session.id },
                update: (cache) =>
                  deleteSessionCache(cache, { id: session.id }),
              });
              toast({ children: 'Session deleted' });
              onClose();
            } catch (error) {
              toast({ children: error.message });
            }
          }}
          isDanger
          isExtended
        >
          Remove
        </Button>
      </ModalPart>
    </Modal>
  );
};

export default DeleteSessionModal;
